/* reset */
button {
  all: unset;
}

.SelectTrigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 0.6rem 1.5rem;
  font-family: 'DM Mono', monospace;
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  line-height: 1;
  gap: 8px;
  background-color: var(--card-bg);
  color: var(--fg);
  border: 1px solid var(--line);
  transition: all 0.3s ease;
}

.SelectTrigger:hover {
  border-color: var(--fg);
  box-shadow: 0 2px 12px var(--shadow);
}

.SelectTrigger:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px var(--accent-soft);
}

.SelectTrigger[data-placeholder] {
  color: var(--muted);
}

.SelectIcon {
  color: var(--muted);
}

.SelectContent {
  overflow: hidden;
  background-color: var(--card-bg);
  border-radius: 12px;
  border: 1px solid var(--line);
  box-shadow: 0 4px 24px var(--shadow);
}

.SelectViewport {
  padding: 6px;
}

.SelectLabel {
  padding: 0.5rem 1rem;
  font-family: 'DM Mono', monospace;
  font-size: 0.6rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  line-height: 25px;
  color: var(--accent);
}

.SelectSeparator {
  height: 1px;
  background-color: var(--line);
  margin: 5px;
}

.SelectItemIndicator {
  position: absolute;
  left: 0;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.SelectScrollButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: var(--card-bg);
  color: var(--muted);
  cursor: default;
}
